export const API_UNAUTHORIZED_EVENT = 'sandrapay:api-unauthorized';

export function emitApiUnauthorized(detail = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(API_UNAUTHORIZED_EVENT, {
    detail,
  }));
}
